import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addUrlParam } from '@/util/utils';
import common from '@/config';
export default {
  name: 'subgroup',
  inject: ["contain", 'container'],
  provide: function provide() {
    return {
      contain: this.contain,
      container: this.container
    };
  },
  props: {
    nav: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      common: common
    };
  },
  methods: {
    getFunction: function getFunction(fun) {
      if (!this.validatenull(fun)) {
        try {
          return eval(fun);
        } catch (_unused) {
          return function () {};
        }
      }
    },
    getJson: function getJson(str) {
      if (this.validatenull(str)) return {};

      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (_unused2) {
          return {};
        }
      }

      return str;
    },
    //点击事件交互
    handleClick: function handleClick(_ref) {
      var _this = this;

      var type = _ref.type,
          child = _ref.child,
          value = _ref.value;
      console.log(type, '---');

      if (type === 'tabs') {
        var indexList = child.index;
        indexList.forEach(function (index) {
          var paramName = child.paramName;

          var item = _this.contain.findlist(index);

          if (!item.url) return;
          var params = {};

          if (item.dataQuery) {
            params = _this.getJson(item.dataQuery);
          } else {
            params = {};
          }

          params[paramName] = value;
          item.dataQuery = JSON.stringify(params);

          _this.$refs[_this.common.NAME + index].forEach(function (ele) {
            ele.updateData();
          });
        });
      }
    },
    //刷新数据
    handleRefresh: function handleRefresh() {
      var tip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.$refs[this.common.NAME + this.contain.activeObj.index][0].updateData();

      if (tip) {
        this.$message.success('刷新成功');
      }
    },
    //获取对象
    handleGetObj: function handleGetObj(val) {
      return this.$refs["".concat(this.common.DEAFNAME).concat(val)];
    },
    handleOver: function handleOver(_ref2) {
      var index = _ref2.index;
      this.contain.overactive = index;
    },
    handleFocus: function handleFocus(_ref3) {
      var index = _ref3.index;
      this.container.gradeFlag = true;

      if (this.contain.keys.ctrl) {
        if (!Array.isArray(this.contain.active)) {
          this.contain.handleInitActive();
        }

        this.contain.active.push(index);
      } else if (!this.contain.active.includes(index)) {
        this.contain.active = [index];
      }
    },
    handleBlur: function handleBlur(_ref4) {
      var left = _ref4.left,
          top = _ref4.top,
          width = _ref4.width,
          height = _ref4.height;
      if (Array.isArray(this.contain.activeObj)) return;
      this.container.gradeFlag = false; // console.log(this.common.NAME, this.contain.activeObj.index, '---commncontain')
      // if (this.contain.activeComponent.name ==='test') {
      //   this.$refs[this.common.NAME + this.contain.activeObj.index][0].updateData();
      // }

      this.$set(this.contain.activeObj.component, 'width', width);
      this.$set(this.contain.activeObj.component, 'height', height);
      this.$set(this.contain.activeObj, 'left', left);
      this.$set(this.contain.activeObj, 'top', top);
    }
  }
};